<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      :class="$vuetify.breakpoint.smAndDown ? 'padding-b' : 'pb-12'"
      :maxwidth-container="$vuetify.breakpoint.mdAndUp ? '820px' : '600px'"
    >
      <v-breadcrumbs
        v-if="$vuetify.breakpoint.mdAndUp"
        :items="menus"
        class="pl-0 mt-6"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled"
            class="body-2"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div
        :class="$vuetify.breakpoint.mdAndUp ? 'padding-lateral' : ''"
      >
        <TituloPagina :titulo="tituloPagina" class="mt-7 mt-md-5" />
        <p class="primary--text mt-5">
          Descreva abaixo as informações sobre a devolução do produto:
        </p>
        <FormDescricaoMotivo
          :codigo-venda="dadosCompra.venda"
          :codigo-reembolso="dadosCompra.codigoReembolso"
          url-envio="refund-request/product-return"
          @respostaApi="trataRespostaApi"
        />
      </div>
      <ModalDevolucaoProduto
        :dialog="dialog"
        :resposta-success="sucesso"
      />
    </InternaMain>
  </Wrapper>
</template>

<script>

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import FormDescricaoMotivo from '@/components/AcompanharSolicitacao/FormDescricaoMotivo.vue';
import ModalDevolucaoProduto from '@/components/AcompanharSolicitacao/ModalDevolucaoProduto.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'DevolucaoProduto',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    FormDescricaoMotivo,
    ModalDevolucaoProduto,
  },

  data() {
    return {
      tituloPagina: 'Informar devolução',
      sucesso: false,
      dialog: false,
      menus: [
        {
          text: 'Minhas Compras',
          disabled: false,
          href: '/minhas-compras/',
        },
        {
          text: 'Acompanhar solicitação',
          disabled: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),
  },

  methods: {
    trataRespostaApi(sucesso) {
      this.sucesso = sucesso;
      this.dialog = true;
    },
  },

};
</script>

<style lang="scss" scoped>
.padding-b { padding-bottom: 70px !important; }
.padding-lateral { padding: 0 100px; }
</style>
